import gql from 'graphql-tag';

export const getScheduledVisits = gql(`
  query getScheduledVisits(
    $channelId: UUID!
    $startDate: DateTime
    $endDate: DateTime
  ) {
    scheduledVisits(
      channelId: $channelId
      startDate: $startDate
      endDate: $endDate
    ) {
      result {
        visits {
          id
          visitor {
            firstName
            lastName
            company
            email
            phone
          }
          accessGrantBuildingId
          hostName
          tenantName
          floor
          companyName
          status
          visitorNote
          staffNote
          startDatetime
          endDatetime
          submittedBy
          eventName
          createdAtDatetime
          sourceId
          submissionId
          validStateTransitions
          recurrenceId
          visitorWatchlistMatchInfo {
            watchlistSeverityLevel
            watchlistId
            isApprovalRequired
            isWatchlistDisplayed
            displayText
          }
          inviteName
        }
        eventNames
        tenantNames
      }
      totalCount
    }
  }
`);
